import { sessionSchema } from "../schemas/auth";
import { fetchApi } from "./internal";

export const session = {
	me: () => fetchApi("/admin/me", sessionSchema),
};
